/**
 *  Типы шифрования данных, поддерживаемые ядром.
 *  @public
 */
export enum DxEncryptionStrategyType {
  BASIC = 'BASIC',
  KEYCLOAK = 'KEYCLOAK'
}
